import { render, staticRenderFns } from "./TabActivites.vue?vue&type=template&id=8d76c8a2&scoped=true&"
import script from "./TabActivites.vue?vue&type=script&lang=js&"
export * from "./TabActivites.vue?vue&type=script&lang=js&"
import style0 from "./TabActivites.vue?vue&type=style&index=0&id=8d76c8a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d76c8a2",
  null
  
)

export default component.exports